import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const projectSwiperInit = () => {
  const projectSwiperArray = [];
  $('.project__swiper').each((index, el) => {
    const paginationEl = $(el).find('.swiper-pagination')[0];
    const prevEl = $(el).find('.swiper-button-prev')[0];
    const nextEl = $(el).find('.swiper-button-next')[0];
    projectSwiperArray[index] = new Swiper(el, {
      slidesPerView: 1,
      // spaceBetween: 10,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
      },
    });
  });
};

const animateNumber = () => {
  document.querySelectorAll('.count').forEach(el => {
    // 移除逗號
    const raw = el.dataset.target.replace(/,/g, '');

    const target = parseFloat(raw);

    // 判斷小數位數
    const decimalLength = raw.includes('.') ? raw.split('.')[1].length : 0;

    const obj = {
      value: 0,
    };

    gsap.to(obj, {
      value: target,
      duration: 2,
      ease: 'power3.out',

      scrollTrigger: {
        trigger: el,
        start: 'top 80%',
        once: true,
      },

      onUpdate() {
        el.textContent = obj.value.toLocaleString(undefined, {
          minimumFractionDigits: decimalLength,
          maximumFractionDigits: decimalLength,
        });
      },

      onComplete() {
        el.textContent = target.toLocaleString(undefined, {
          minimumFractionDigits: decimalLength,
          maximumFractionDigits: decimalLength,
        });
      },
    });
  });
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  projectSwiperInit();
  animateNumber();
};

// Vue
createApp({
  setup() {
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {};
  },
}).mount('#main');
